// extracted by mini-css-extract-plugin
export default {"pageNotFound":"styles_pageNotFound__8Sqip"};